import type { KeyboardEvent } from 'react'

const UP = 'ArrowUp'
const DOWN = 'ArrowDown'

const findNextFocusableSibling = (elem: HTMLElement): HTMLElement | null => {
  if (!elem.nextSibling) return null
  const nextSibling = elem.nextSibling as HTMLElement
  return nextSibling.tabIndex >= 0
    ? nextSibling
    : findNextFocusableSibling(nextSibling)
}

const findPreviousFocusableSibling = (
  elem: HTMLElement
): HTMLElement | null => {
  if (!elem.previousSibling) return null
  const previousSibling = elem.previousSibling as HTMLElement
  return previousSibling.tabIndex >= 0
    ? previousSibling
    : findPreviousFocusableSibling(previousSibling)
}

export const handleSidebarRowNavigationKeys = (
  event: KeyboardEvent<HTMLElement>,
  previousKey: string = UP,
  nextKey: string = DOWN
) => {
  const elem = event.currentTarget as HTMLElement
  if (event.key === nextKey) {
    event.preventDefault()
    findNextFocusableSibling(elem)?.focus()
  }
  if (event.key === previousKey) {
    event.preventDefault()
    findPreviousFocusableSibling(elem)?.focus()
  }
}
